import { render, staticRenderFns } from "./Ecology.vue?vue&type=template&id=4e4662fa&scoped=true&"
import script from "./Ecology.vue?vue&type=script&lang=js&"
export * from "./Ecology.vue?vue&type=script&lang=js&"
import style0 from "./Ecology.vue?vue&type=style&index=0&id=4e4662fa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e4662fa",
  null
  
)

export default component.exports